import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
    name: "gallery",
    _selector: "[data-slideshow-gallery-id]",
    init() {
        const swipers = document.querySelectorAll(this._selector);

        if (swipers.length) {
            for (let i = 0; i < swipers.length; i++) {
                let swiperId = swipers[i].getAttribute("data-slideshow-gallery-id");

                let el = document.querySelector(`[data-slideshow-gallery-id="${swiperId}"]`)
                let slides = el.getAttribute("data-slides") ?? 1;

                let config = {
                    loop: false,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    dynamicBullets: true,
                    pagination: {
                        el: '.swiper-pagination-'+swiperId,
                        clickable: true,
                        dynamicBullets: true,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next-"+swiperId,
                        prevEl: ".swiper-button-prev-"+swiperId,
                        disabledClass: "swiper-button-disabled"
                    },
                }

                let swiper = new Swiper(el, config);
            }
        }
    },
};
